// extracted by mini-css-extract-plugin
export default {"admission_header":"Header_admission_header__MVNJu","header_button":"Header_header_button__4i6tY","header_text":"Header_header_text__CnWLn"};